import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, Attributes, SubTypeMap} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class RoadlabelExpressionBuilderService {
    title = 'RoadLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[10] = {function: this.buildRoadAnnotation.bind(this)};
        this.subTypeMap[11] = {function: this.buildRoadWideningAnnotation.bind(this)};
    }

    build(attributes: Attributes) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes);
    }

    formatLabel(value: string, size: number, normal: boolean) {
        return this.labelExpressionUtilityService.formatLabel(value, size, normal);
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties(fontSize, fontStyle, textAnchor, attributes);
    }

    buildRoadAnnotation(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1.toUpperCase(), 14, true) + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute1.toUpperCase()));
        }

        if (attributes.attribute2) {
            attribute2 = this.formatLabel(attributes.attribute2.toUpperCase(), 14, true) + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute2.toUpperCase()));
        }

        if (attributes.attribute3) {
            attribute3 = this.formatLabel(attributes.attribute3.toUpperCase(), 14, true);
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute3.toUpperCase()));
        }

        labelValue = (attribute1 + attribute2 + attribute3).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildRoadWideningAnnotation(attributes: Attributes) {
        let attribute1 = '';
        let attribute2 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1.toUpperCase(), 10, false) + '\n';
            labels.push(this.getLabelProperties('10em', 'italic', 'middle', attributes.attribute1.toUpperCase()));
        }

        let roundedNumber = undefined;
        let area = undefined;

        if (attributes.attribute2) {
            if (!isNaN(attributes.attribute2)) {
                area = attributes.attribute2;

                if (area >= 10000) {
                    area = area / 10000;
                    roundedNumber = this.labelExpressionUtilityService.round(area, 4);
                    labelValue = roundedNumber + 'ha';
                } else {
                    roundedNumber = this.labelExpressionUtilityService.round(area, 0);
                    labelValue = roundedNumber + 'm' + '\u00b2';
                }

                attribute2 = this.formatLabel(labelValue, 10, false) + '\n';
                labels.push(this.getLabelProperties('10em', 'italic', 'middle', labelValue));
            }
        }

        labelValue = (attribute1 + attribute2).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }
}
